import FinancesScene from './FinancesScene'
export default FinancesScene